import { RootState } from '../../../../rootReducer';
import { ICurrentDistribution } from './interfaces';

const selectCurrentDistributionBase = (state: Pick<RootState, 'credits'>) => state.credits.distribution.creditPools.current;

export const selectCurrentDistributionLoading = (state: Pick<RootState, 'credits'>): boolean => selectCurrentDistributionBase(state).loading;
export const selectCurrentDistribution = (state: Pick<RootState, 'credits'>): ICurrentDistribution | undefined => selectCurrentDistributionBase(state).value;
export const selectHasCurrentDistribution = (state: Pick<RootState, 'credits'>): boolean => !!selectCurrentDistribution(state);
export const selectIsNewDistributionMode = (state: Pick<RootState, 'credits'>): boolean => selectCurrentDistributionBase(state).isNewDistribution;
export const selectIsCreditPoolDistributionSaving = (state: Pick<RootState, 'credits'>): boolean => selectCurrentDistributionBase(state).saving;
